const NAVIGATION_BUTTON_CLICK = 'NAVIGATION_BUTTON_CLICK';
const CLEAR_LOADER = 'CLEAR_LOADER';

const events = [
  NAVIGATION_BUTTON_CLICK,
  CLEAR_LOADER
];

const initializeEventListeners = () => {
  EVENT_BUS.registerEvents(events);
};

export const ARP_NAVIGATION_EVENTS = {
  initializeEventListeners,
  NAVIGATION_BUTTON_CLICK,
  CLEAR_LOADER,
};
